// US-6165: upload jobs (JobId <acct>-SNO-<id>, <acct>-SCO-<id>, <acct>-SNT-<id>, and the non-OCR coding
// upload <acct>-SNU-<id>) are created locked ([E-Sign] = 1). Only 998 super users (internal ops) may edit
// their demographics and re-assign the patient; to everyone else they stay locked. SNC and FAXED jobs are
// not upload jobs here. The WebApi enforces the same rule from the stored job; this only decides what the
// screen enables.

const UPLOAD_JOB_ID = /^.+-(SNO|SCO|SNT|SNU)-\d+$/;

export const isUploadJob = (jobId) => typeof jobId === 'string' && UPLOAD_JOB_ID.test(jobId);
// Name used by the Corrected upload change (US-6183); same rule.
export const isOcrUploadJob = isUploadJob;

// A Coding upload marked "Corrected report" is created as <acct>-CORRECTED-<id>, locked like SNO/SCO.
// The Coding Inbox's manual "Corrected Job" uses the same prefix but is created unlocked, so only a
// LOCKED CORRECTED job is treated as an upload job here. The WebApi decides from the stored job
// whether OCR created it; a locked manual CORRECTED job keeps today's server rule.
const CORRECTED_JOB_ID = /^.+-CORRECTED-\d+$/;

export const isLockedCorrectedJob = (jobId, eSigned) => eSigned === true && typeof jobId === 'string' && CORRECTED_JOB_ID.test(jobId);

// "998 super user": home account 998, the existing isInRole('Admin') rule (the WebApi also requires a
// current active 998 employee).
const isSuperUser998 = (auth) => auth.isInRole('Admin') === true;

// SNT (transcription upload) jobs are typed reports: the body stays editable until the job is signed;
// once signed, only a 998 super user with Save may edit it (the WebApi refuses everyone else).
const SNT_JOB_ID = /^.+-SNT-\d+$/;

// Report text is read-only on faxed jobs, on SNO/SCO/SNU upload jobs (the report is the uploaded
// document), on a signed SNT job unless the user is a 998 super user with Save, and on a locked
// CORRECTED job.
export const isReportTextReadOnly = (jobId, eSigned, auth) => {
    if (typeof jobId !== 'string') return false;
    if (SNT_JOB_ID.test(jobId)) return eSigned === true && !(auth && auth.isInRole('Save') && isSuperUser998(auth));
    return jobId.indexOf('FAXED') > -1 || isUploadJob(jobId) || isLockedCorrectedJob(jobId, eSigned);
};

// Edit Patient Data and Re-assign Patient. Unchanged for every job that is not a locked upload job:
// enabled only when the job is not signed and the user has the Save role.
export const canEditPatientData = (patient, auth) => {
    if (!patient || !auth.isInRole('Save')) return false;
    if (!patient.ESigned) return true;
    return (isUploadJob(patient.JobId) || isLockedCorrectedJob(patient.JobId, patient.ESigned)) && isSuperUser998(auth);
};



// WEBPACK FOOTER //
// ./src/utils/lockedJobEdit.js